export const hoverMenu = {
  namespaced: true,
  state: {
    insight: false,
    reviews: false,
    visitors: false,
    locationStore: false,
    gmbPosts: false,
    snsPosts: false,
    keywordAnalysis: false,
    products: false
  },
  mutations: {
    toggleHoverMenu(state, payload) {
      state[payload] = !state[payload]
    }
  },
  actions: {
    toggleHoverMenu({ commit }, payload) {
      commit('toggleHoverMenu', payload)
    },
  }
}
